import React from 'react';

export default function Overlay({ onClick }: { onClick?: () => void }) {
  return <div className="cow-overlay" onClick={onClick} />;
}
